import { render, staticRenderFns } from "./ClausesUpdate.vue?vue&type=template&id=6a728188"
import script from "./ClausesUpdate.vue?vue&type=script&lang=js"
export * from "./ClausesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports